import { render, staticRenderFns } from "./ModelAddGift.vue?vue&type=template&id=ef26c14a"
import script from "./ModelAddGift.vue?vue&type=script&lang=js"
export * from "./ModelAddGift.vue?vue&type=script&lang=js"
import style0 from "./ModelAddGift.vue?vue&type=style&index=0&id=ef26c14a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports